var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9496 9.28034H10.7637V5.00026C10.8839 4.53995 10.4883 4.16699 10.0001 4.16699C9.51185 4.16699 9.11627 4.53995 9.23642 5.00026V9.28034H5.05056C4.56232 9.16706 4.16675 9.54001 4.16675 10.0003C4.16675 10.4606 4.56232 10.8336 5.05056 10.7203H9.23642V15.0004C9.11627 15.4607 9.51185 15.8337 10.0001 15.8337C10.4883 15.8337 10.8839 15.4607 10.7637 15.0004V10.7203H14.9496C15.4378 10.8336 15.8334 10.4606 15.8334 10.0003C15.8334 9.54001 15.4378 9.16706 14.9496 9.28034Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.c54d4664c2a17b29a4a1188d50c07001.svg";
export { ForwardRef as ReactComponent };